import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
 
window.Alpine = Alpine;
 
Alpine.start();
Alpine.plugin( collapse );